if (!customElements.get("cart-upsells")) {
  customElements.define(
    "cart-upsells",
    class CartUpsells extends HTMLElement {
      constructor() {
        super();

        this.nextButtonEl = this.querySelector(".is-next");
        this.prevButtonEl = this.querySelector(".is-prev");
        this.itemTrack = this.querySelector(".cart-upsells__items");

        this._handleNextClick = this.handleNextClick.bind(this);
        this._handlePrevClick = this.handlePrevClick.bind(this);
        this._updateButtonState = this.updateButtonState.bind(this);
      }
      connectedCallback() {
        this.nextButtonEl.addEventListener("click", this._handleNextClick);

        this.prevButtonEl.addEventListener("click", this._handlePrevClick);

        this.itemTrack.addEventListener("scroll", this._updateButtonState, {
          passive: true,
        });

        this.updateButtonState();
      }

      disconnectedCallback() {
        this.nextButtonEl?.removeEventListener("click", this._handleNextClick);

        this.prevButtonEl?.removeEventListener("click", this._handlePrevClick);

        this.itemTrack?.removeEventListener("scroll", this._updateButtonState);
      }

      getSlideWidth() {
        const item = this.itemTrack.querySelector(".cart-upsells__item");

        if (!item) return 0;

        const styles = window.getComputedStyle(this.itemTrack);

        const gap = parseFloat(styles.columnGap) || parseFloat(styles.gap) || 0;

        return item.offsetWidth + gap;
      }

      handleNextClick() {
        const slideWidth = this.getSlideWidth();

        const maxScrollLeft =
          this.itemTrack.scrollWidth - this.itemTrack.clientWidth;

        const currentScrollLeft = this.itemTrack.scrollLeft;

        const nextPosition = currentScrollLeft + slideWidth;

        this.itemTrack.scrollTo({
          left: Math.min(nextPosition, maxScrollLeft),
          behavior: "smooth",
        });
      }

      handlePrevClick() {
        const currentScrollLeft = this.itemTrack.scrollLeft;

        if (currentScrollLeft <= 1) return;

        const previousPosition = Math.max(
          currentScrollLeft - this.getSlideWidth(),
          0,
        );

        this.itemTrack.scrollTo({
          left: previousPosition,
          behavior: "smooth",
        });
      }

      updateButtonState() {
        const maxScrollLeft =
          this.itemTrack.scrollWidth - this.itemTrack.clientWidth;

        const isAtStart = this.itemTrack.scrollLeft <= 1;

        const isAtEnd = this.itemTrack.scrollLeft >= maxScrollLeft - 1;

        this.prevButtonEl.toggleAttribute("disabled", isAtStart);

        this.nextButtonEl.toggleAttribute("disabled", isAtEnd);
      }
    },
  );
}
